<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card :title="'DEFAULT MARGIN FOR PRICING'" class="">
        <template slot="actions">
          <vs-button v-can="'view-margin-costs-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus"
            class="mr-4" color="primary" type="filled" v-if="margin_list.length < 4">create</vs-button>
        </template>
        <div id="margin-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="margin_list">
              <template slot="thead">
                <vs-th width="30%">FG TYPE</vs-th>
                <vs-th width="20%">DEFAULT MARGIN (%)</vs-th>
                <vs-th width="30%">NOTES</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_type">
                    {{ data[indextr].formulation_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].margin">
                    {{ data[indextr].margin }}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    <vx-read-more :length="100" :text="data[indextr].note" />
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-margin-costs-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small"
                          color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-margin-cost-pop-up ref="addNewMarginCostPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewMarginCostPopUp from '@/components/popups/settings/margin-cost/AddNewMarginCostPopUp.vue';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
const MarginCostRepository = RepositoryFactory.get('margin_cost');

export default {
  name: "MarginListSettings",
  data() {
    return {
      margin_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    AddNewMarginCostPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchMarginList()
    },
    async fetchMarginList() {
      await this.$vs.loading({
        container: '#margin-list-table',
        scale: 0.45
      })
      const { data } = await MarginCostRepository.getMarginCostList(this.page, this.filterQuery, this.perPage, this.sort)
      this.margin_list = data.data
      this.meta = data.meta
      this.$vs.loading.close('#margin-list-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.addNewMarginCostPopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.addNewMarginCostPopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await MarginCostRepository.deleteMarginCost(params[0])
        await this.fetchMarginList()
        await this.showSuccessMessage('Margin cost deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchMarginList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchMarginList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchMarginList()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    await this.fetchMarginList()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchMarginList()
    },
    perPage() {
      this.fetchMarginList()
    }
  }
}
</script>

<style scoped></style>
